<template>
  <div class=" " >
    <loading-block v-if="is_load_projects==false" :loading="!is_load_projects"/>
    <div class="" v-if="is_load_projects">
      <div class="section_header mobile_div row mt-4 mb-4 " v-if="services.length>0">

        <div class="col-md-6 mt-2 col-12">
          <select class="form-control" @change="changeFilter" v-model="service_id_choose">
            <option value="0">Все услуги</option>
            <option :value="service.last_id" v-for="(service,project_index) in services" :key="service.last_id">{{ service.name }}</option>


          </select>
        </div>

      </div>
      <ProjectFreelanceCard :project="project" v-if="projects.length>0"
                   v-for="(project,project_index) in projects" :key="project.last_id"/>
      <div class="section_header  mobile_div mt-2 mb-2" v-if="projects.length==0">
        <h2 v-if="projects.length==0" class="text-center">По вашему запросу ничего не найдено!</h2>
      </div>

      <div class="row mt-2 text-center" v-if="projects.length>0">
        <div class="col-6  " >

          <button v-if=" count>0 && offset>0" @click="prevBtn" class="btn">Назад</button>
          <button v-if="!( count>0 && offset>0)" disabled   class="btn disabled">Назад</button>
        </div>

        <div class="col-6  " >
          <button @click="nextBtn" v-if="count>next_offset" class="btn">Вперед</button>
          <button   v-if="!(count>next_offset)" disabled class="btn ">Вперед</button>
        </div>

        <!--                <base-pagination :per-page="projects_table.on_page" :total="projects_table.total"-->
        <!--                                 v-model="projects_table.current_page"></base-pagination>-->
      </div>
    </div>


  </div>

</template>

<script>
import LoadingBlock from "@/components/Custom/LoadingBlock";
import ProjectFreelanceCard from "@/components/Custom/ProjectFreelanceCard";
import Api from "@/models/Api";
export default {
  name: "ListFreelanceRequest",
  components: {LoadingBlock,ProjectFreelanceCard},
  data() {

    var app = this;

    return {
      "is_load_projects": false,
      'limit':20,
      'offset':0,
      'projects':[],
      'count':0,
      'service_id_choose':0,
      'services':[],

    }
  },
  mounted: function () {
    var app=this;

    Api.loadFreelanceWithFilterv2(app.limit,app.offset,app.getFilter(),function (data) {
      app.services=data.services;
      app.projects = data.projects;
      app.is_load_projects=true;

      app.next_offset=data.offset;
      app.count=data.count;


    });


  },
  methods:{
    getFilter(){

      var app=this;
      var filter={};
      filter.service_id=app.service_id_choose;
      return filter;
    },
    changeFilter(){
      var app=this;
      app.is_load_projects=false;
      Api.loadFreelanceWithFilterv2(app.limit,app.offset,app.getFilter(),function (data) {
        app.services=data.services;
        app.projects = data.projects;
        app.is_load_projects=true;

        app.next_offset=data.offset;
        app.count=data.count;


      });
    },
    prevBtn(){
      var app=this;
      app.is_load_projects=false;
      var offset=app.offset;
      offset=offset-app.limit;

      if(offset>=0){
        Api.loadFreelanceWithFilterv2(app.limit,offset,app.getFilter(),function (data) {
          app.projects = data.projects;
          app.offset=offset;
          app.next_offset=data.offset;


          app.is_load_projects=true;

        });
      }
    },
    nextBtn(){

      var app=this;
      app.is_load_projects=false;
      if(app.next_offset>app.offset){
        Api.loadFreelanceWithFilterv2(app.limit,app.next_offset,app.getFilter(),function (data) {
          app.projects = data.projects;
          app.offset=app.next_offset;
          app.next_offset=data.offset;


          app.is_load_projects=true;
        });
      }
    },
  }

}
</script>

<style scoped>

</style>